import { Stack, Box, Typography, Button } from "@mui/material";
import SearchableSelect from "@components/atoms/SearchableSelect/SearchableSelect";
import InputText from "@components/atoms/InputText/InputText";
import MyButton from "@components/atoms/MyButton/MyButton";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import { PencilSquare, XOctagon } from "react-bootstrap-icons";
import { grey } from "@mui/material/colors";
import { ICreateReceiptTopUI } from "src/types/molecules";
const CreateReceiptTopUI = ({
  register,
  setValue,
  productSelect,
  customPrice,
  toggleCustomPrice,
  totalPriceValue,
  addProduct,
  showError,
  onCloseError,
  isLoading,
  query
}: ICreateReceiptTopUI) => {
  return <>
      <Stack component="form" direction={"row"} justifyContent={"space-between"} alignItems={"flex-end"} flexWrap={"wrap"} noValidate onKeyDown={e => e.key.toLowerCase() === "enter" ? addProduct() : null}>
        <Box marginBottom={2} width={0.49}>
          <SearchableSelect label="Producto" placeholder="Selecciona producto" loading="Cargando productos" errorMessage="Error obteniendo productos" primaryKey="description" secondaryKey="reference" query={query} register={register("item", {
          required: true,
          validate: (value: string | undefined) => value !== "-1"
        })} watchValue={productSelect} reset={() => setValue("item", undefined)} disabled={isLoading} />
        </Box>
        <Box marginBottom={2} width={0.49}>
          <InputText label="Cantidad" name="quantity" placeholder="Ingresa cantidad" register={register("quantity", {
          required: true,
          valueAsNumber: true
        })} disabled={isLoading} />
        </Box>
        <Box marginBottom={2} width={0.49}>
          <Stack direction={"row"} alignItems={"flex-end"} spacing={1}>
            <Box width={1}>
              <InputText label="Precio por unidad" name="price" disabled={!customPrice} register={register("price", {
              required: true
            })} />
            </Box>
            <MyButton sx={{
            height: 47
          }} onClick={toggleCustomPrice}>
              {customPrice ? <XOctagon size={25} /> : <PencilSquare size={25} />}
            </MyButton>
          </Stack>
        </Box>
        <Stack direction={"row"} justifyContent={"space-between"} flexWrap={"wrap"} width={0.49} bgcolor={grey[100]} borderRadius={1.5} paddingY={1.3} paddingX={2} marginBottom={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" width={1}>
            <Typography>Precio total</Typography>
            <Typography fontSize={"1.2rem"} color={grey[800]} fontWeight={800}>
              {totalPriceValue || "0"} COP
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Stack direction={"row"} justifyContent={"flex-end"} marginBottom={3}>
        <Button onClick={addProduct} disabled={isLoading}>
          Agregar
        </Button>
      </Stack>
      <ErrorAlert open={showError} onClose={onCloseError} message={"Error, no se puede agregar el mismo producto dos veces"} duration={3000} />
    </>;
};
export default CreateReceiptTopUI;